export default {
    default: {
        mainColor: '00b0f2',
        // 金色
        // flyParticles: 'efdb6a',
        flyParticles: '00b0f2',
        rootPoi: '44B3E3',
        otherPoi: '107BA8'
    },
    gold: {
        mainColor: 'FFF87E',
        flyParticles: 'efdb6a',
        rootPoi: 'BEA636',
        otherPoi: '9B882D'
    }
};
